import { isProductPublicationSubscription, isProductRegularSubscription, isProductSingleIssue } from '@pressreader/commerce-types';
import { IIssueInfoPurchaseInfo } from '@pressreader/content-types';

import { AnyPurchaseProductDto } from '../types';
import { IIssueSubscriptionInfoDto } from '../types/issue.subscription.info';

import { mapFromProductDto } from './product.mapper';

function mapIssuePurchaseInfo(subscriptionInfoDto: IIssueSubscriptionInfoDto, productDtos: AnyPurchaseProductDto[]): IIssueInfoPurchaseInfo {
    const products = productDtos.map(mapFromProductDto);
    return {
        isFreeContent: subscriptionInfoDto.IsFreeContent,
        requiredAuthenticatedUser: subscriptionInfoDto.RequiredAuthenticatedUser,
        singleIssueProduct: products.find(isProductSingleIssue),
        premiumProduct: products.filter(isProductRegularSubscription).find(p => p.tags.indexOf('premium') >= 0),
        selectProduct: products.filter(isProductRegularSubscription).find(p => p.tags.indexOf('selectPlan') >= 0),
        singleTitleProduct: products.find(isProductPublicationSubscription),
    };
}

export { mapIssuePurchaseInfo };
